import { Flex, Text } from "@gravity-ui/uikit";
import cn from "classnames";
import { useTranslate } from "src/i18n";

import { VariantTreeDto } from "../../../../VariantTreeDto";
import { ProductPriceDetailsButton } from "./components";
import { ProductPriceDetailsSkeleton } from "./ProductPriceDetailsSkeleton";
import css from "./ProductPriceDetailsSkeleton.module.scss";

interface ProductPriceDetailsProps {
  isLoading: boolean;
  variants?: VariantTreeDto | null;
  isBlur: boolean;
  selected: Record<string, string>;
  onChange: (next: Record<string, string>) => void;
}

export const ProductPriceDetails = ({
  isLoading,
  variants,
  isBlur,
  selected,
  onChange,
}: ProductPriceDetailsProps) => {
  if (isLoading) return <ProductPriceDetailsSkeleton />;
  if (!variants) return null;

  const { attributes } = variants;

  if (!attributes || Object.keys(attributes).length === 0) {
    return <ProductPriceZero />;
  }

  return (
    <Flex direction="column" gap={2}>
      {Object.entries(attributes).map(([attributeName, values]) => (
        <Flex key={attributeName} direction="column" gap={1}>
          <Text
            variant="subheader-2"
            color="secondary"
            className={cn({ [css.blur]: isBlur })}
          >
            {attributeName}
          </Text>

          <Flex gap={2} wrap>
            {values.map((value) => (
              <div key={value}>
                <ProductPriceDetailsButton
                  isBlur={isBlur}
                  value={value}
                  selected={selected}
                  attributeName={attributeName}
                  onChange={onChange}
                />
              </div>
            ))}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

const ProductPriceZero = () => {
  const { t } = useTranslate();

  return (
    <Text variant="subheader-2">
      {t("cost_zero", "Цены нет,выберите другую платформу")}
    </Text>
  );
};
